export function Create(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/activities`;
}

export function Delete(organizationID: number, activityID: number): string {
	return `/v1/organizations/${organizationID}/user-activities/${activityID}`;
}

export function EventIndex(organizationID: number, eventID: number): string {
	return `/v1/organizations/${organizationID}/events/${eventID}/activities`;
}

export function GroupIndex(organizationID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/groups/${groupID}/activities`;
}

export function Update(organizationID: number, activityID: number): string {
	return `/v1/organizations/${organizationID}/user-activities/${activityID}`;
}

export function UserIndex(organizationID: number, userID: number): string {
	return `/v1/organizations/${organizationID}/users/${userID}/activities`;
}

